<template>
    <div v-if="text"
         class="error-message text-center orange--text">
        <i class="fas fa-exclamation-triangle mr-1" />
        {{ text }}
    </div>
</template>

<script>
export default {
    props: {
        text: {
            required: true,
            type: String,
        },
    },
};
</script>
